import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=edc2c59e&scoped=true&"
import script from "./ProfilePicture.vue?vue&type=script&lang=js&"
export * from "./ProfilePicture.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePicture.vue?vue&type=style&index=0&id=edc2c59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc2c59e",
  null
  
)

export default component.exports